
// // src/pages/auth/Login.jsx
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { authAPI } from '../../api/auth.api';
// import Input from '../../components/common/Input';
// import Button from '../../components/common/Button';
// import styles from './Login.module.css';

// const Login = () => {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPasswordField, setShowPasswordField] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [emailError, setEmailError] = useState('');

//   const validateEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(email);
//   };

//   const handleEmailSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setEmailError('');

//     if (!email.trim()) {
//       setEmailError('Email is required');
//       return;
//     }

//     if (!validateEmail(email)) {
//       setEmailError('Please enter a valid email');
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await authAPI.login(email, '');
      
//       if (response.requiresOtp) {
//         navigate('/verify-otp', { 
//           state: { 
//             email, 
//             isFirstTime: true,
//             message: response.message 
//           } 
//         });
//       } else {
//         setShowPasswordField(true);
//       }
//     } catch (err) {
//       const errorMessage = err.message;
      
//       if (errorMessage.includes('Password is required')) {
//         setShowPasswordField(true);
//       } else {
//         setError(errorMessage);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (!password.trim()) {
//       setError('Password is required');
//       return;
//     }

//     setLoading(true);
//     console.log('🔐 Starting login...');

//     try {
//       const response = await authAPI.login(email, password);
//       console.log('📥 Full response:', response);
      
//       if (response.message === 'Login successful') {
//         console.log('✅ Login successful condition met');
        
//         if (response.token) {
//           localStorage.setItem('auth_token', response.token);
//           console.log('💾 Token stored in localStorage:', response.token);
          
//           const stored = localStorage.getItem('auth_token');
//           console.log('✅ Verified token in storage:', stored);
//         } else {
//           console.log('⚠️ No token in response!');
//         }
        
//         setTimeout(() => {
//           console.log('🚀 Navigating to /dashboard');
//           navigate('/dashboard', { replace: true });
//         }, 100);
//       } else {
//         console.log('❌ Login message was:', response.message);
//       }
//     } catch (err) {
//       console.error('❌ Login error:', err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//       console.log('🏁 Login process finished');
//     }
//   };

//   const handleBack = () => {
//     setShowPasswordField(false);
//     setPassword('');
//     setError('');
//   };

//   return (
//     <div className={styles.container}>
//       <div className={styles.card}>
//         <h1 className={styles.title}>Welcome Back</h1>
//         <p className={styles.subtitle}>
//           {showPasswordField ? 'Enter your password' : 'Enter your email to continue'}
//         </p>

//         {error && (
//           <div className={`${styles.alert} ${styles.alertError}`}>
//             {error}
//           </div>
//         )}

//         {!showPasswordField ? (
//           <form className={styles.form} onSubmit={handleEmailSubmit}>
//             <Input
//               type="email"
//               label="Email Address"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               error={emailError}
//               disabled={loading}
//             />
//             <Button type="submit" fullWidth loading={loading}>
//               Continue
//             </Button>
//           </form>
//         ) : (
//           <form className={styles.form} onSubmit={handlePasswordSubmit}>
//             <Input
//               type="email"
//               label="Email Address"
//               value={email}
//               disabled
//             />
//             <Input
//               type="password"
//               label="Password"
//               placeholder="Enter your password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               disabled={loading}
//               autoFocus
//             />
//             <Button type="submit" fullWidth loading={loading}>
//               Login
//             </Button>
//             <button 
//               type="button" 
//               className={styles.link} 
//               onClick={handleBack}
//             >
//               Use different email
//             </button>
//             <button 
//               type="button" 
//               className={styles.link} 
//               onClick={() => navigate('/forgot-password', { state: { email } })}
//             >
//               Forgot Password?
//             </button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Login;
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../api/auth.api';
import logo from '../../assets/images/density_logo_new_trans.png';
import styles from './Login.module.css';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPasswordField, setShowPasswordField] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setEmailError('');
    if (!email.trim()) { setEmailError('Email is required'); return; }
    if (!validateEmail(email)) { setEmailError('Please enter a valid email'); return; }
    setLoading(true);
    try {
      const response = await authAPI.login(email, '');
      if (response.requiresOtp) {
        navigate('/verify-otp', { state: { email, isFirstTime: true, message: response.message } });
      } else {
        setShowPasswordField(true);
      }
    } catch (err) {
      if (err.message.includes('Password is required')) {
        setShowPasswordField(true);
      } else {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!password.trim()) { setError('Password is required'); return; }
    setLoading(true);
    try {
      const response = await authAPI.login(email, password);
      if (response.message === 'Login successful') {
        if (response.token) {
          localStorage.setItem('auth_token', response.token);
        }
        setTimeout(() => navigate('/dashboard', { replace: true }), 100);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setShowPasswordField(false);
    setPassword('');
    setError('');
  };

  return (
    <div className={styles.root}>
      {/* LEFT PANEL */}
      <div className={styles.left}>
        <div className={styles.leftBg} />
        <div className={styles.gridOverlay} />
        <div className={`${styles.orb} ${styles.orb1}`} />
        <div className={`${styles.orb} ${styles.orb2}`} />
        <div className={`${styles.orb} ${styles.orb3}`} />
        <div className={styles.leftContent}>
          <div className={styles.divider} />
          <div className={styles.tagline}>
            Density —<br />
            <span>Happy to be</span><br />
            <em>bothered.</em>
          </div>
          <p className={styles.leftSub}>
            Your workspace for data-driven decisions — precise, fast, and beautifully simple.
          </p>
          <div className={styles.badgeRow}>
            <span className={styles.badge}>Analytics</span>
            <span className={styles.badge}>Real-time</span>
            <span className={styles.badge}>Insights</span>
          </div>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className={styles.right}>
        <div className={`${styles.rightInner} ${mounted ? styles.mounted : ''}`}>

          <div className={styles.logoWrap}>
            <img src={logo} alt="Density" className={styles.logoImg} />
          </div>

          <h1 className={styles.heading}>
            {showPasswordField ? <>Enter your <em>password.</em></> : <>Welcome <em>back.</em></>}
          </h1>
          <p className={styles.subtitle}>
            {showPasswordField
              ? 'Almost there — one last step.'
              : 'Sign in to continue to your workspace.'}
          </p>

          {error && (
            <div className={styles.errorBox}>
              <svg className={styles.errorIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {error}
            </div>
          )}

          {!showPasswordField ? (
            <form className={styles.form} onSubmit={handleEmailSubmit} autoComplete="off">
              <div className={styles.field}>
                <label className={styles.label}>Email address</label>
                <input
                  className={`${styles.input} ${emailError ? styles.inputError : ''}`}
                  type="email"
                  placeholder="you@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                  autoFocus
                />
                {emailError && <div className={styles.fieldError}>{emailError}</div>}
              </div>
              <button className={styles.btnPrimary} type="submit" disabled={loading}>
                <span className={styles.btnInner}>
                  {loading && <span className={styles.spinner} />}
                  {loading ? 'Checking…' : 'Continue →'}
                </span>
              </button>
            </form>
          ) : (
            <form className={styles.form} onSubmit={handlePasswordSubmit}>
              <div className={styles.emailChip}>
                <span className={styles.chipDot} />
                <span className={styles.chipText}>{email}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Password</label>
                <input
                  className={styles.input}
                  type="password"
                  placeholder="••••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  autoFocus
                />
              </div>
              <button className={styles.btnPrimary} type="submit" disabled={loading}>
                <span className={styles.btnInner}>
                  {loading && <span className={styles.spinner} />}
                  {loading ? 'Signing in…' : 'Sign in →'}
                </span>
              </button>
              <div className={styles.linksRow}>
                <button type="button" className={styles.linkBtn} onClick={handleBack}>
                  ← Different email
                </button>
                <button
                  type="button"
                  className={styles.linkBtn}
                  onClick={() => navigate('/forgot-password', { state: { email } })}
                >
                  Forgot password?
                </button>
              </div>
            </form>
          )}

          <div className={styles.footer}>© {new Date().getFullYear()} Density Pharmachem. All rights reserved.</div>
        </div>
      </div>
    </div>
  );
};

export default Login;